import { render } from "./FunctionsCatalogOutputColumn.vue?vue&type=template&id=1a990f1d&scoped=true&ts=true"
import script from "./FunctionsCatalogOutputColumn.vue?vue&type=script&lang=ts"
export * from "./FunctionsCatalogOutputColumn.vue?vue&type=script&lang=ts"

import "./FunctionsCatalogOutputColumn.vue?vue&type=style&index=0&id=1a990f1d&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a990f1d"]])

export default __exports__